<template>
  <!-- <edit-last-mile /> -->
  <div></div>
</template>

<script>
// import EditLastMile from "@/components/3pl/Settings/RoutesAndVehicles/Routes/SingleRoute/Edit/EditLastMile";
export default {
  components: {
    // EditLastMile,
  },
};
</script>

<style></style>
